<template>
    <div class="create-holiday">
        <v-dialog :value="value.state" @click:outside="close" @keydown.esc="close" max-width="400">
             <v-card>
                <v-card-title>
                    {{ value.item === undefined ? "Tạo mới " : "Cập nhật "}} ngày lễ
                </v-card-title>
                <v-form @submit.prevent="saveData" v-model="valid" ref="form">
                    <v-card-text>
                        <v-row>
                            <v-col cols="12">
                                <v-text-field
                                clearable
                                v-model="form.name"
                                label="Ngày lễ"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12">
                                <v-text-field
                                clearable
                                v-model="form.symbol"
                                label="Ký hiệu"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12">
                                <v-text-field
                                clearable
                                v-model="form.scale"
                                label="Hệ số"
                                type="number"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12">
                                <date-picker v-model="form.date"></date-picker>
                            </v-col>
                            <v-col cols="12">
                                <v-switch v-model="form.isActive" label="Kích hoạt"> </v-switch>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn dark
                            color="blue darken-1"
                            type="submit"
                        >
                            Lưu
                        </v-btn>
                        <v-spacer></v-spacer>
                    </v-card-actions>
                </v-form>
             </v-card>
        </v-dialog>
    </div>
</template>

<script>
import http from '@/components/services/http-common';
import DatePicker from '@/components/DatePicker'
import EventBus  from "@/components/services/EventBus";

export default {
    name: "CreateHoliday",
    components: {
        "date-picker": DatePicker,
    },
    computed:{

    },
    watch: {
        value: {
            handler(val){
                if(val.item != undefined)
                    this.fetchData();
                if(val.state)
                    return val || this.close();
            }
        },
    },

    props: ["value"],
    data () {
        return {
            //URL
            ROOT_URL: "holidays",

            //DÂTA
            valid: false,
            ShiftObject: "",
            formData: {

            },
            form: {
                code:"auto",
                name: "",
                symbol: "NL",
                scale: 1,
                date: new Date().toISOString().substring(0,10),
                isActive: true,
            },

            defaultForm: {
                code:"auto",
                name: "",
                symbol: "NL",
                scale: 1,
                date: new Date().toISOString().substring(0,10),
                isActive: true,
            },

            //EMPLOYEE DIALOG
            employeeDialog: false,
            selectedField: "",
        }
    },
    methods: {
        messageToast (eventObj) {
            EventBus.$emit('hasMessage', eventObj);
        },

        formatTime(value) {
            return moment(value).format("HH:mm:ss");
        },

        close () {
            this.$emit("CloseDialog");
            this.$refs.form.resetValidation();
            this.form = Object.assign({}, this.defaultForm);
        },
        
        fetchData () {
            return http.get(this.ROOT_URL + "/" + this.value.item.code)
            .then(res => {
                let item = res.data;
                this.form = Object.assign({}, item);
                this.form.date = this.form.date.toLocaleString("en-US", {timeZone: "Asia/Ho_Chi_Minh"}).substr(0, 10);
            })
            .catch(err => {
                console.log(err);
            });
        },
        saveData() {
            let  isValid = this.$refs.form.validate();
            console.log(isValid);
            if(isValid)
            {
                if(!this.value.item)
                {
                    http.post(this.ROOT_URL, this.form)
                    .then(res => {
                        let eventObj = {
                            color: "success",
                            message: "Tạo mới thành công",
                            toast: true,
                        };
                        this.messageToast(eventObj);
                        this.$emit("fetchData");
                    })
                    .catch(err => {
                    });
                } else {
                    http.put(this.ROOT_URL + "/" + this.value.item.code, this.form)
                    .then(res => {
                        let eventObj = {
                            color: "success",
                            message: "Cập nhật thành công",
                            toast: true,
                        };
                        this.messageToast(eventObj);
                        this.$emit("fetchData");
                    })
                    .catch(err => {
                        throw "Đã có lỗi xảy ra"
                    });
                }
                this.close();
            }
        },
        
        //Employee Dialog JS
        rowHandler (e) {
            this.form.EmployeeCode = e.code;
            this.form.EmployeeName = e.name;
        }
    },
    created() {

    }
}
</script>